import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import ComicGrid from './components/ComicGrid';
import CTASection from './components/CTASection';
import SEOHead from '@/components/base/SEOHead';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '爱漫画',
  url: 'https://aimanga.com/',
  description: '爱漫画汇聚无删减韩国漫画，提供下拉式免费韩漫大全在线阅读，优质韩漫作品持续上新。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://aimanga.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '爱漫画',
  url: 'https://aimanga.com/',
  description: '爱漫画是国内领先的韩国漫画在线阅读平台，致力于为广大韩漫爱好者提供无删减、高品质的韩漫阅读体验。',
  email: 'contact@aimanga.com',
  foundingDate: '2020',
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="首页"
        description="爱漫画汇聚无删减韩国漫画，提供下拉式免费韩漫大全在线阅读，优质韩漫作品持续上新，热门连载、完结漫画一网打尽，满足您对韩漫的多样需求。"
        keywords="韩国漫画,无删减漫画,下拉式韩漫,免费韩漫大全,爱漫画"
        canonicalUrl="https://aimanga.com/"
        schema={{ ...orgSchema, ...homeSchema }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeatureGrid />
        <ComicGrid />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}